(function () {
  if (window.__swymWishlistReady) return;
  window.__swymWishlistReady = true;

  // ponytail: Swym's own auto-bound button (class="swym-button" data-swaction="addToWishlist")
  // would need zero JS, but it injects its own icon markup and owns the button's
  // inner HTML — incompatible with the theme's custom SVG + .wishlist-toggle-btn--active
  // styling. This wires the same Swym APIs to the existing button instead.

  var wishlisted = new Set(); // variant ids (epi) as strings, per the last fetch

  // A fetch issued right after add/delete can still return the pre-mutation list, which
  // would strip the class we just set (heart stays empty until reload). So a click's known
  // outcome outranks the fetched list for that epi, until a fetch agrees and clears it.
  var pending = new Map(); // epi (string) -> desired boolean

  function isOn(epi) {
    return pending.has(epi) ? pending.get(epi) : wishlisted.has(epi);
  }

  function syncButtonStates() {
    document.querySelectorAll('.wishlist-toggle-btn').forEach(function (btn) {
      btn.classList.toggle('wishlist-toggle-btn--active', isOn(String(currentVariantId(btn))));
    });
  }

  // On product pages the button's data-variant-id goes stale between renders.
  // The product form's input[name="id"] is always current (updateVariantInputs keeps it
  // in sync before afterVariantChanged fires). Collection cards have no data-section-id.
  function currentVariantId(btn) {
    var sectionId = btn.dataset.sectionId;
    if (sectionId) {
      var input = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
    }
    return parseInt(btn.dataset.variantId, 10);
  }

  function variantPrice(btn, variantId) {
    if (btn.dataset.sectionId) {
      try {
        var el = document.getElementById('variant-prices-json');
        if (el) {
          var prices = JSON.parse(el.textContent);
          if (prices[variantId]) return prices[variantId].price;
        }
      } catch (_) {}
    }
    return parseInt(btn.dataset.productPrice, 10);
  }

  // image_url emits a root-relative /cdn/shop/... path, which resolves against whatever
  // origin rendered the page — under `shopify theme dev` that is 127.0.0.1:9292. Swym
  // persists `iu` server-side, so a dev-host URL would be saved and stay broken forever.
  // data-product-link is built from {{ shop.url }}, so it is the canonical base.
  // Resolving against it is correct for root-relative, protocol-relative and absolute src.
  function absoluteUrl(src, base) {
    try {
      return new URL(src, base).href;
    } catch (_) {
      return src;
    }
  }

  function productPayload(btn) {
    var variantId = currentVariantId(btn);
    return {
      empi: parseInt(btn.dataset.productId, 10), // product id
      epi: variantId, // variant id
      du: btn.dataset.productLink, // product url
      dt: btn.dataset.productTitle, // display title
      iu: absoluteUrl(btn.dataset.productImage, btn.dataset.productLink), // image url
      pr: variantPrice(btn, variantId) / 100, // Swym wants major currency units, not cents
    };
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    // Fail loudly rather than silently no-op if Swym's API shape ever changes.
    ['addToWishList', 'deleteFromWishList', 'fetchWrtEventTypeET'].forEach(function (fn) {
      if (typeof swat[fn] !== 'function') console.error('[swym-wishlist] missing swat.' + fn);
    });

    function refresh() {
      swat.fetchWrtEventTypeET(function (products) {
        wishlisted = new Set((products || []).map(function (p) {
          return String(p.epi);
        }));
        // Retire each optimistic entry the fetch has caught up with; a still-stale one
        // keeps winning until the next fetch confirms it.
        pending.forEach(function (want, epi) {
          if (wishlisted.has(epi) === want) pending.delete(epi);
        });
        syncButtonStates();
      }, swat.EventTypes.addToWishList);
    }

    refresh();

    // Variant change replaces the picker DOM — the new button has no active class.
    document.addEventListener('afterVariantChanged', syncButtonStates);

    // Swym's own drawer can add/remove items without going through our button.
    if (swat.evtLayer && swat.JSEvents) {
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, refresh);
      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, refresh);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.wishlist-toggle-btn');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;

      var product = productPayload(btn);
      var epi = String(product.epi);
      var turningOn = !isOn(epi);

      btn.disabled = true;
      var settle = function (ok) {
        return function () {
          if (ok) {
            pending.set(epi, turningOn);
            syncButtonStates();
          }
          btn.disabled = false;
          refresh();
        };
      };

      if (turningOn) {
        swat.addToWishList(product, settle(true), settle(false));
      } else {
        swat.deleteFromWishList(product, settle(true), settle(false));
      }
    });
  });
})();
